<template>
  <div>
    Index Région Supervisée
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
